const columns = [
  {
    field: 'CreateTime',
    headerName: '下单时间',
    width: 150
  },
  {
    field: 'Status',
    headerName: '状态',
    minWidth: 70,
    cellRenderer(params) {
      let statesstr = '';
      switch (params.value) {
        case 1:
        case 2:
        case 6:
          statesstr = '处理中';
          break;
        case 3:
          statesstr = '已发货';
          break;
        case 4:
          statesstr = '已完成';
          break;
        case 5:
          statesstr = '已取消';
          break;
        default:
          break;
      }
      return statesstr;
    },
    cellStyle(params) {
      let style = { color: '#000' };
      switch (params.value) {
        case 1:
        case 2:
        case 6:
          style.color = '#EE7700';
          break;
        case 3:
          style.color = '#009DD9';
          break;
        case 4:
          style.color = '#139C25';
          break;
        case 5:
          style.color = '#ff2200';
          break;
        default:
          break;
      }
      return style;
    }
  },
  {
    field: 'OrderNo',
    headerName: '订单编号',
    width: 120
  },
  {
    field: 'PartNo',
    headerName: '型号'
  },
  {
    field: 'Brand',
    headerName: '品牌'
  },
  {
    field: 'Package',
    headerName: '封装'
  },
  {
    field: 'MakeYear',
    headerName: '年份',
    width: 60
  },
  {
    field: 'Qty',
    headerName: '数量',
    width: 60
  },
  {
    field: 'Price',
    headerName: '单价',
    width: 60
  },
  {
    field: 'Amount',
    headerName: '小计',
    width: 80
  },
  {
    field: 'OrderAmount',
    headerName: '订单总额',
    width: 80
  },
  {
    field: 'IsInvoice',
    headerName: '税',
    width: 80,
    cellRenderer(params) {
      return params.value ? '含税' : '不含税';
    }
  },
  {
    field: 'BuyerCompany',
    headerName: '供应商'
  },
  {
    field: 'Contact',
    headerName: '联系人',
    cellRenderer(params) {
      return params.data.BuyerContactInfo
        ? params.data.BuyerContactInfo.Contact
        : '';
    }
  },
  {
    field: 'Phone',
    headerName: '联系电话',
    cellRenderer(params) {
      return params.data.BuyerContactInfo
        ? params.data.BuyerContactInfo.Phone
        : '';
    }
  },
  {
    field: 'OperationLog',
    headerName: '操作',
    cellRendererFramework: 'GridRenderCellLog',
    width: 100
  }
];

export { columns };
